/**
 * Footer Accordion
 *
 * Collapses the footer link menus below 768px, where four open menus push the
 * legal notices a long way down the page. The first menu is left open so the
 * footer does not read as a row of empty headings.
 *
 * Panels are open in the markup, so without JavaScript — and at every width
 * above the breakpoint — every link is visible. Above the breakpoint the
 * headings are disabled rather than left as controls that do nothing.
 */
(function () {
    'use strict';

    var QUERY = '(max-width: 767px)';

    function init() {
        var columns = document.querySelectorAll('[data-footer-column]');

        if (!columns.length) {
            return;
        }

        var query = window.matchMedia(QUERY);

        function pair(column) {
            return {
                toggle: column.querySelector('[data-footer-toggle]'),
                panel: column.querySelector('[data-footer-panel]')
            };
        }

        function open(toggle, panel, isOpen) {
            toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            panel.hidden = !isOpen;
        }

        function apply() {
            Array.prototype.forEach.call(columns, function (column, i) {
                var parts = pair(column);

                if (!parts.toggle || !parts.panel) {
                    return;
                }

                if (query.matches) {
                    parts.toggle.disabled = false;
                    // Only the first menu starts open.
                    open(parts.toggle, parts.panel, i === 0);
                } else {
                    parts.toggle.disabled = true;
                    open(parts.toggle, parts.panel, true);
                }
            });
        }

        Array.prototype.forEach.call(columns, function (column) {
            var parts = pair(column);

            if (!parts.toggle || !parts.panel) {
                return;
            }

            parts.toggle.addEventListener('click', function () {
                open(parts.toggle, parts.panel, parts.toggle.getAttribute('aria-expanded') !== 'true');
            });
        });

        apply();

        if (typeof query.addEventListener === 'function') {
            query.addEventListener('change', apply);
        } else if (typeof query.addListener === 'function') {
            query.addListener(apply);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
